import type { CowryGeometryParams, GeometryConstraints } from "../core/types";

export const milestoneOneCowryParams: CowryGeometryParams = {
  shellLength: 3.3,
  shellWidth: 1.72,
  shellHeight: 1.42,
  dorsalBulge: 0.24,
  endTaper: 0.72,
  ventralFlatness: 0.58,
  ventralRecessWidth: 0.14,
  ventralFoldCurve: 0,
  longitudinalAsymmetry: 0.022,
};

export const cowryGeometryRanges: GeometryConstraints = {
  shellLength: { min: 3.08, max: 3.52 },
  shellWidth: { min: 1.58, max: 1.84 },
  shellHeight: { min: 1.32, max: 1.54 },
  dorsalBulge: { min: 0.17, max: 0.31 },
  endTaper: { min: 0.65, max: 0.8 },
  ventralFlatness: { min: 0.53, max: 0.63 },
  ventralRecessWidth: { min: 0.115, max: 0.165 },
  ventralFoldCurve: { min: -0.055, max: 0.055 },
  longitudinalAsymmetry: { min: -0.028, max: 0.028 },
};
